import { Decimal } from "shared-ts/classes/decimal"
import { MAX_DECIMAL_QUANTITY_PLACES } from "shared-ts/utils"

type UseDecimalQuantitiesOperationsRes = {
  numberDecimalPlaces: number
  decimalFormat: (quantity: Decimal, allowDecimalQuantities: boolean) => string
}

export function useDecimalQuantitiesOperations(): UseDecimalQuantitiesOperationsRes {
  const numberDecimalPlaces = MAX_DECIMAL_QUANTITY_PLACES

  const decimalFormat = (quantity: Decimal, allowDecimalQuantities: boolean) =>
    allowDecimalQuantities
      ? quantity.round(numberDecimalPlaces).toString()
      : quantity.round(0).toString()

  return {
    numberDecimalPlaces,
    decimalFormat,
  }
}
